/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pr_Type_VmaInputs */

const fr_pr_type_vma = /** @type {(inputs: Pr_Type_VmaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VMA`)
};

/**

* @param {Pr_Type_VmaInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const pr_type_vma = /** @type {((inputs?: Pr_Type_VmaInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pr_Type_VmaInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_pr_type_vma(inputs)
});